import React, { useState } from 'react';

import { postJSON } from '../../api/client.js';
import { UniActionButton, UniPageShell, useUniList } from '../waba/WabaShared.jsx';
import { RAG_API } from './RagPages.jsx';

export default function RagTestChat() {
  const systems = useUniList(`${RAG_API}/systems/`);
  const [system, setSystem] = useState('');
  const [audience, setAudience] = useState('customer');
  const [message, setMessage] = useState('');
  const [log, setLog] = useState([]);
  const [busy, setBusy] = useState(false);

  const send = async () => {
    const text = message.trim();
    if (!text) return;
    setMessage('');
    setLog((prev) => [...prev, { role: 'user', content: text }]);
    setBusy(true);
    try {
      const data = await postJSON(`${RAG_API}/test-chat/`, {
        message: text,
        system: system || undefined,
        audience,
      });
      const reply = data?.result?.response || data?.result || data;
      setLog((prev) => [...prev, { role: 'assistant', content: typeof reply === 'string' ? reply : JSON.stringify(reply, null, 2), raw: data }]);
    } catch (e) {
      setLog((prev) => [...prev, { role: 'assistant', content: e.message }]);
    } finally {
      setBusy(false);
    }
  };

  return (
    <UniPageShell
      theme="rag"
      icon="💬"
      title="Test chat"
      subtitle="Talk to the AI without sending WhatsApp. Same engine the inbox uses."
      helpPage="test_chat"
      helpApi={RAG_API}
      actions={<UniActionButton hero to="/rag">← Home</UniActionButton>}
    >
      <div className="rag-chat">
        <div style={{ display: 'flex', gap: 8 }}>
          <select value={system} onChange={(e) => setSystem(e.target.value)} style={{ flex: 1, padding: 6 }}>
            <option value="">Default system</option>
            {systems.rows.map((s) => (
              <option key={s.id} value={s.slug || s.id}>{s.icon} {s.name}</option>
            ))}
          </select>
          <select value={audience} onChange={(e) => setAudience(e.target.value)} style={{ padding: 6 }}>
            <option value="customer">Customer</option>
            <option value="distributor">Distributor</option>
          </select>
        </div>
        <div className="rag-chat__log">
          {log.length === 0 && <div className="uni-num--muted">Ask anything about your knowledge base.</div>}
          {log.map((m, i) => (
            <div key={i} className={`waba-bubble ${m.role === 'user' ? 'waba-bubble--out' : 'waba-bubble--in'}`}>
              {m.content}
            </div>
          ))}
        </div>
        <div className="waba-compose">
          <textarea
            rows={2}
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); send(); }
            }}
            placeholder="Message…"
          />
          <button type="button" className="ty-btn" disabled={busy} onClick={send}>
            {busy ? '…' : 'Send'}
          </button>
        </div>
      </div>
    </UniPageShell>
  );
}
